import * as stat from "jstat";
export const sampleDistribution = (def) => {
    switch (def.distribution) {
        case "normal":
            return stat.normal.sample(def.mean ?? 1, def.std ?? 1);
        case "log-normal":
            return stat.lognormal.sample(def.mu ?? 1, def.sigma ?? 1);
        case "poisson":
            return stat.poisson.sample(def.rate);
        case "beta":
            return stat.beta.sample(def.alpha ?? 1, def.beta ?? 1);
        case "gamma":
            return stat.gamma.sample(def.shape ?? 1, def.scale ?? 1);
        default:
            return stat.normal.sample(1, 1);
    }
};
//# sourceMappingURL=montecarlo.js.map